import { govPoolABI } from '../abi';

export const kardiaStakePools = [
    {
        id: 'sen-kai',
        name: 'SEN',
        logo: 'single-assets/SEN.png',
        token: 'SEN',
        tokenDecimals: 18,
        tokenAddress: '0xb697231730C004110A86f51BfF4B8DD085c0CB28',
        tokenOracle: 'tokens',
        tokenOracleId: 'SEN',
        earnedToken: 'KAI',
        earnedTokenDecimals: 18,
        earnedTokenAddress: '0xAF984E23EAA3E7967F3C5E007fbe397D8566D23d',
        earnContractAddress: '0x4F193C46120b046Fe934De0F4E83bB4AA19907da',
        earnContractAbi: govPoolABI,
        earnedOracle: 'tokens',
        earnedOracleId: 'WKAI',
        partnership: false,
        status: 'active',
        hideCountdown: true,
        partners: [
            {
                logo: 'single-assets/SEN.png',
                background: '',
                text: "SleepEarn Finance is a Decentralized, Yield Optimizer platform on KardiaChain that allows its users to earn compound interest on their crypto holdings.",
                website: 'https://sleepearn.finance/',
                social: {
                    telegram: 'https://t.me/sleepearn',
                    twitter: 'https://twitter.com/sleepearn',
                },
            },
        ],
    },
    {
        id: 'sen-kai-blk',
        name: 'SEN-KAI',
        logo: 'single-assets/BLK.png',
        token: 'pillowBecoSEN-KAI',
        tokenDecimals: 18,
        tokenAddress: '0x27ea5A8A132ADfc27d44aBA450091d3738fC32cC',
        tokenOracle: 'tokens',
        tokenOracleId: 'pillowBecoSEN-KAI',
        earnedToken: 'Blanket',
        earnedTokenDecimals: 18,
        earnedTokenAddress: '0xe8E41385b4Dd2Df285b3E48b0B59bDb4dFBAaaF2',
        earnContractAddress: '0xd978f166d19c82d0dDeD52924405c900ad3A878b',
        earnedTokenType: "nft",
        earnContractAbi: govPoolABI,
        earnedOracle: 'tokens',
        earnedOracleId: 'BLK',
        partnership: false,
        status: 'active',
        hideCountdown: false,
        // periodFinish: 1630324800,
        partners: [
            {
                logo: 'single-assets/SEN.png',
                background: '',
                text: "SleepEarn Finance is a Decentralized, Yield Optimizer platform on KardiaChain that allows its users to earn compound interest on their crypto holdings.",
                website: 'https://sleepearn.finance/',
                social: {
                    telegram: 'https://t.me/sleepearn',
                    twitter: 'https://twitter.com/sleepearn',
                },
            },
        ],
    },
    {
        id: 'kphi-kai-blk',
        name: 'KPHI-KAI',
        logo: 'single-assets/BLK.png',
        token: 'pillowBecoKPHI-KAI',
        tokenDecimals: 18,
        tokenAddress: '0xCeb5E1bE5c2cD29259AfeD0D40B83825B949151C',
        tokenOracle: 'tokens',
        tokenOracleId: 'pillowBecoKPHI-KAI',
        earnedToken: 'Blanket',
        earnedTokenDecimals: 18,
        earnedTokenAddress: '0xe8E41385b4Dd2Df285b3E48b0B59bDb4dFBAaaF2',
        earnContractAddress: '0x02CB267c9cb8eFCA8e858171D310E84d186ad20E',
        earnedTokenType: "nft",
        earnContractAbi: govPoolABI,
        earnedOracle: 'tokens',
        earnedOracleId: 'BLK',
        partnership: false,
        status: 'active',
        hideCountdown: false,
        // periodFinish: 1635552000,
        partners: [
            {
                logo: 'single-assets/KPHI.png',
                background: '',
                text: "Kephi Gallery is a marketplace where artists from different disciplines can get together and share (and monetize!) their work. From visual arts, to music, from movie clips to even theatre, every artist is welcome to mint their NFT and start trading their pieces of art.",
                website: 'https://www.kephi.io',
                social: {
                    telegram: 'https://t.me/KephiGallery',
                    twitter: 'https://twitter.com/KephiGallery',
                },
            },
        ],
    }
];
